import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Message from '../Message/Message';
import styles from './MessagesList.module.css';

const MessagesList = ({
  messages,
  authorFontSize,
  currentState,
  winId,
  speed,
}) => {
  return (
    <div className={styles['wrapper']}>
      {currentState &&
        (currentState === 'S1' ||
          currentState === 'S2' ||
          (currentState === 'S3' && messages.length >= 2)) && (
          <div className={styles['messagesWrapper']}>
            <TransitionGroup className={styles['messages']} appear={true}>
              {messages.length > 0 &&
                messages.map((item, i) => (
                  <CSSTransition
                    key={item.UUID}
                    timeout={speed}
                    classNames="position"
                  >
                    <Message
                      winId={winId}
                      key={item.id}
                      message={item.message}
                      authorFontSize={authorFontSize}
                      currentState={currentState}
                    />
                  </CSSTransition>
                ))}
            </TransitionGroup>
          </div>
        )}
    </div>
  );
};

export default MessagesList;
